import { Box, Button, Tab, Tabs, Typography } from '@mui/material'
import React, { useEffect, useMemo, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import LegalAgreement from './tabs/LegalAgreement'
import SupportSections from './tabs/SupportSections'
import { apiClient } from '../utils'

const SuperadminView = () => {
  const navigate = useNavigate()

  const checkIsSuperadmin = () => {
    const isSuperadmin = true

    if (!isSuperadmin) {
      return navigate('/')
    }
  }

  useEffect(() => {
    checkIsSuperadmin()
  }, [])

  const tabs = useMemo(() => [
    // {
    //   label: 'Legal Agreement',
    //   Component: LegalAgreement,
    // },
    {
      label: 'Support Sections',
      Component: SupportSections,
    },
  ])

  const [tab, setTab] = useState(0)

  const { Component } = tabs[tab]

  return (
    <>
      <Box sx={{ p: 4 }}>
        <Button sx={{ float: 'right' }} onClick={() => apiClient.logout()}>
          Log out
        </Button>
        <Typography variant='h4' sx={{ mb: 2 }}>
          StartUP CRM Super Admin Tools
        </Typography>
        <Box
          sx={{
            display: 'flex',
            height: '100%',
            flexDirection: 'column',
            alignItems: 'center',
          }}
        >
          <Tabs
            value={tab}
            onChange={(_e, value) => setTab(value)}
            centered
            sx={{ mb: 1 }}
          >
            {tabs.map((t) => (
              <Tab label={t.label} key={t.label}></Tab>
            ))}
          </Tabs>
          <Component />
        </Box>
      </Box>
    </>
  )
}

export default SuperadminView
